import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import vuetify from './plugins/vuetify'
import { firestorePlugin } from 'vuefire'
import Vue2Filters from 'vue2-filters'
import VueMeta from 'vue-meta'
import {setupVeeValidate} from "@/plugins/vee-validate";
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

import {setupGlobalComponents} from '@/components'


Vue.use(Vue2Filters)
Vue.use(firestorePlugin)
Vue.use(VueMeta, {
    keyName: 'metaInfo',
    attribute: 'data-vue-meta',
    ssrAttribute: 'data-vue-meta-ssr',
    tagIDKeyName: 'vmid',
    refreshOnceOnNavigation: true
})
Vue.use(VuetifyGoogleAutocomplete, {
    apiKey: 'AIzaSyBzVLZrdgyz62bydqWVsvclvI87I_V9Ho4',
  });

setupVeeValidate();
setupGlobalComponents();

Vue.config.productionTip = false
/* eslint-disable-line no-new */
new Vue({
    el: '#app',
    vuetify,
    router,
    store,
    render: (h) => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered")),
    components: { App }
  })


//   <v-autocomplete
//   v-if="spec.type === SpecType.autocomplete"
//   v-model="item[spec.value]"
//   :items="autocomplete(spec.value)"
//   :label="spec.text"
//   v-on:blur="summit(spec.value)"
// ></v-autocomplete>
